$produktSlider = [];
let sliderFunctions = [];

$('.js-produkt_slider').each(function(){

    const $slider = $(this);
    const id = $slider.data("id");
    const slides = $slider.find(".swiper-slide").length;
    const autoplayAllowed = $slider.data("autoplay") === 1;
    const loop = slides > 6;

    sliderFunctions[$(this).data("id")] = [];
    sliderFunctions[$(this).data("id")]["autoplay"] = autoplayAllowed;
    sliderFunctions[$(this).data("id")]["loop"] = loop;

    $produktSlider[$(this).data("id")] = new Swiper('.js-produkt_slider-' + $(this).data("id"), {
        slidesPerView:1,
        spaceBetween: 2,
        loop: loop,

        autoplay: autoplayAllowed ? {
            delay: 5000
        } : false,

        preloadImages: false,
        lazy:{
                loadPrevNext: 2,
                lazyPreloaderClass: '.swiper-lazy-preloader'
        },


        navigation: {
            nextEl: '.js-produkt_slider_item-next-' + id,
            prevEl: '.js-produkt_slider_item-prev-' + id
        },

        breakpoints: {
            321: { slidesPerView: Math.min(1, slides) },
            380: { slidesPerView: Math.min(2, slides) },
            640: { slidesPerView: Math.min(3, slides) },
            768: { slidesPerView: Math.min(4, slides) },
            1024: { slidesPerView: Math.min(5, slides) },
            1200: { slidesPerView: Math.min(6, slides) }
        }
    });

    $produktSlider[$(this).data("id")].init();
    if(!autoplayAllowed) $produktSlider[$(this).data("id")].autoplay.stop();

    let sliderId = $(this).data("id");

    //Accessibility
    //Focus soll Autoplay und Loop stoppen
    $slider.find(".swiper-slide a").each(function(){
        $(this).on('focus',function(){
            $produktSlider[sliderId].autoplay.stop();
            $produktSlider[sliderId].params.loop = false;
        });

        $(this).on('blur',function(){
            if(sliderFunctions[sliderId]["autoplay"]){
                $produktSlider[sliderId].autoplay.start();
            }
            if(sliderFunctions[sliderId]["loop"]){
                $produktSlider[sliderId].params.loop = true;
            }
        });
    })
});